<template>
  <div>

    <div class="banner"></div>
    <div class="header">
      <img :src='peopleMessage.avatar | imageUrl("/static/profile_img_default.png",40,40)'
           :alt="$t('global.头像')"
           class="headPicture">
      <div class="name">{{peopleMessage.nickname}} <img v-if="peopleMessage.isPersonalCertification"
             src="/static/peopleCenter/head.png"
             alt=""><img v-if="peopleMessage.isArtist"
             src="/static/peopleCenter/headDouble.png"
             alt=""></div>
      <div class="code">{{peopleMessage.signature}}</div>
      <div class="location-wrap">
        <div class="profession">{{peopleMessage.career}}</div>
        <div class="verticalLine"></div>
        <div class="location"> {{peopleMessage.area}} </div>
      </div>
    </div>
    <div class="tabs-wrap">
      <div class="tabs"
           v-for="(item ,index) in tabsContent"
           :key="index"
           :class="{'choose':activeIndex===index}"
           @click="changeIndex(index)">{{item}}</div>
    </div>
    <div class="product"
         v-if="activeIndex===0">
      <div class="order">
        <div v-for="(item,index) in orderList"
             :key="index"
             :class="{sort:contentIndex===index}"
             @click="videoListF(index)">
          <img :src="item.imgType">
          <span>{{item.name}} </span>
        </div>
      </div>
      <div class="container box">
        <item v-for="(item,index) in list"
              :key="index"
              :id="item.videoId"
              :title="item.name"
              :url="item.url"
              :thumb="item.thumb"
              :nickName="item.nickname"
              :avatar="item.avatar"
              :userId="item.userId"
              :cat="item.industry +'-'+ item.profession"></item>
      </div>
    </div>

  
    <BriefIntroduction v-if="activeIndex===2"
                       :peopleMessage=peopleMessage></BriefIntroduction>
    <pages v-if="activeIndex!==2"></pages>

  </div>
</template>

<script type="text/ecmascript-6">
import item from '../components/item.vue'
import pages from '../components/pages.vue'
import BriefIntroduction from '../components/CORBriefIntroduction.vue'
export default {
  metaInfo() {
    return {
      title: this.$t("global.简介") + " | MANA"
    };
  },
  data() {
    return {
      activeIndex: 0,
      tabsContent: [this.$t('global.作品集'), this.$t('global.活动'), this.$t('global.简介')],
      peopleMessage: {},
      userId: '',
      list: [],
      contentIndex: 0,
      orderList: [
        { name: this.$t('global.最新创作'), imgType: '/static/peopleCenter/new.png' },
        { name: this.$t('global.按浏览量'), imgType: '/static/peopleCenter/eye.png' },
        { name: this.$t('global.按点赞数'), imgType: '/static/peopleCenter/hand.png' },
        { name: this.$t('global.按评论数'), imgType: '/static/peopleCenter/message.png' }
      ],
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    }
  },
  components: {
    item,
    pages,
    BriefIntroduction
  },
  created() {
    this.userId = this.$query.userId
    this.info()
    this.videoListF(0, 1)
  },
  methods: {
    gotoVideo(videoId) {
      this.$router.push('/Video/detail?id=' + videoId)
    },
    changeIndex(index) {
      this.activeIndex = index
      switch (index) {
        case 0:
          this.videoListF(0, 1)
          break
        case 2:
          this.activityListF(1, 1)
          break
      }
    },
    info() {
      this.$http.get('/api/customer/info/' + this.userId).then(response => {
        this.peopleMessage = response.data
      })
    },
    videoListF(index, pageI) {
      this.contentIndex = index
      let url = ''
      if (this.activeIndex === 0) {
        url = '/api/customer/videoList/'
      } else if (this.activeIndex === 1) {
        url = '/api/customer/likeList/'
      }
      let order = ''
      switch (index) {
        case 0:
          order = 'createTime'
          break
        case 1:
          order = 'viewCount'
          break
        case 2:
          order = 'likeCount'
          break
        case 3:
          order = 'commentCount'
          break
      }
      this.$http
        .get(url + this.userId, {
          params: {
            orderBy: order,
            pageIndex: pageI || this.pagerParam.currentPage
          }
        })
        .then(response => {
          let data = response.data
          this.list = data.list
          this.pagerParam.pageSize = data.pageSize
          this.pagerParam.total = data.totalRecord
          this.pagerParam.pageCount = data.totalPage
          this.pagerParam.currentPage = data.pageIndex
        })
    },
    activityListF() {
      this.$http
        .get('/api/customer/activityList/' + this.userId, {
          params: {
            orderBy: order,
            pageIndex: pageI || this.pagerParam.currentPage
          }
        })
        .then(response => {
          let data = response.data
          this.list = data.list
          this.pagerParam.pageSize = data.pageSize
          this.pagerParam.total = data.totalRecord
          this.pagerParam.pageCount = data.totalPage
          this.pagerParam.currentPage = data.pageIndex
        })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.order
    display flex
    width 16rem
    overflow hidden
    margin 0 auto
    color #777777
    .sort
        color #333333
        font-weight bold
    >div
        margin 0.5rem 0 0 0.3rem
    img
        width 0.16rem
        margin-top -0.04rem
    span
        display inline-block
        margin-left 0.1rem
.foucus
    margin-top 0.47rem
.one-people
    display flex
    justify-content space-between
    border-bottom 2px solid #dddddd
    padding 0.4rem 0
    .fleft
        display flex
        img
            width 1.3rem
            height 1.3rem
        .fname-wrap
            margin-left 0.3rem
            .fname
                font-size 0.26rem
                line-height 0.26rem
                color #333333
                margin-top 0.08rem
            .fdesc
                font-size 0.16rem
                line-height 0.26rem
                color #777777
                margin-top 0.12rem
            .fbutton
                width 1.2rem
                height 0.42rem
                line-height 0.42rem
                text-align center
                font-size 0.16rem
                color #ffffff
                background-color #0060ff
                border-radius 0.19rem
                margin-top 0.2rem
    .fright
        display flex
        img
            display block
            width 2.06rem
            height 1.16rem
            margin-left 0.1rem
.box
    display flex
    margin-top 0.3rem
    .item
        margin-right 0.26rem
        // flex 1
        &:nth-child(4)
            margin-right 0
.filter
    background-color #fff
    border-bottom-left-radius 0.06rem
    border-bottom-right-radius 0.06rem
.tabs-wrap
    background #ffffff
    height 0.85rem
    line-height 0.85rem
    margin 0.2rem 0
    padding 0 4.64rem
    display flex
    color #777777
    font-size 0.26rem
    justify-content space-around
    .tabs
        padding 0 0.03rem
    .choose
        border-bottom 2px solid #333333
        color #333333
        font-weight bold
.header
    height 2.2rem
    background #ffffff
    text-align center
    font-size 0.2rem
    position relative
    /* line-height 0.26rem */
    .name
        padding-top 0.85rem
        font-size 0.24rem
        font-weight bold
        img
            width 0.28rem
            height 0.28rem
            margin-left 0.15rem
    .location-wrap
        display flex
        padding 0 7.47rem
        color #777777
        justify-content space-between
        .verticalLine
            width 2px
            height 0.22rem
            position relative
            top 0.05rem
            background-color #EBEBEB
.headPicture
    display block
    width 1.5rem
    height 1.5rem
    left 0
    right 0
    margin 0 auto
    position absolute
    top -0.75rem
.banner
    width 100%
    height 3.6rem
    background url('/static/peopleCenter/1.png') no-repeat
    background-size 100%
</style>



// WEBPACK FOOTER //
// src/pages/CorporationHome.vue